import React from "react";
import { FcRules } from "react-icons/fc";

const RulesLogo = () => <FcRules color="black" size={"40px"} />;

export default RulesLogo;
